// components/CategoryManagementModal/CategoryManagementModal.styles.ts
import { SxProps, Theme } from '@mui/material/styles';

export const categoryManagementModalStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 2,
      boxShadow: (theme: Theme) => theme.shadows[10],
    },
  } as SxProps<Theme>,
  
  title: {
    padding: 3,
    borderBottom: '1px solid',
    borderBottomColor: 'divider',
  } as SxProps<Theme>,
  
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  } as SxProps<Theme>,
  
  closeButton: {
    color: 'text.secondary',
    '&:hover': {
      color: 'text.primary',
    },
  } as SxProps<Theme>,
  
  content: {
    padding: 3,
  } as SxProps<Theme>,
  
  categoriesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  } as SxProps<Theme>,
  
  categoryItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: 2,
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    '&:hover': {
      backgroundColor: 'grey.50',
    },
  } as SxProps<Theme>,
  
  categoryName: {
    fontWeight: 500,
    color: 'text.primary',
  } as SxProps<Theme>,
  
  actionButton: {
    minWidth: 100,
    textTransform: 'none',
    fontWeight: 500,
  } as SxProps<Theme>,
  
  attachButton: {
    minWidth: 100,
    textTransform: 'none',
    fontWeight: 500,
    backgroundColor: 'primary.main',
    color: 'primary.contrastText',
    '&:hover': {
      backgroundColor: 'primary.dark',
    },
  } as SxProps<Theme>,
  
  detachButton: {
    minWidth: 100,
    textTransform: 'none',
    fontWeight: 500,
    borderColor: 'error.main',
    color: 'error.main',
    '&:hover': {
      borderColor: 'error.dark',
      backgroundColor: 'error.light',
      color: 'error.dark',
    },
  } as SxProps<Theme>,
  
  actions: {
    padding: 3,
    borderTop: '1px solid',
    borderTopColor: 'divider',
  } as SxProps<Theme>,
  
  closeActionButton: {
    borderColor: 'grey.400',
    color: 'text.secondary',
    '&:hover': {
      borderColor: 'grey.600',
      backgroundColor: 'grey.50',
    },
  } as SxProps<Theme>,
};